import { Modal } from "antd";
import { useModalConfiguration } from "../../../contexts/calendar/ModalConfigurationContext.context";
import UserConfigBoard from "../../common/UserConfigBoard.calendar";

export const ModalConfiguration = () => {
    const { setOptions, options } = useModalConfiguration();

    const cerrar = () => {
        setOptions((prev) => ({
            ...prev,
            isopen: false,
            id: '',
            isConfigUser: false
        }));
    };

    return (
        <Modal
            title="Configuración de Usuario"
            open={options.isopen}
            onCancel={cerrar}
            maskClosable={false}
            footer={null}
            width={options.width || "600px"}
            destroyOnHidden
        >
            <div className="mt-4">
                <UserConfigBoard />
            </div>
        </Modal>
    );
};
